/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsUsageRouteImport } from './routes/settings.usage'
import { Route as SettingsSecurityRouteImport } from './routes/settings.security'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsDownloadsRouteImport } from './routes/settings.downloads'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as ProjectsIdRouteImport } from './routes/projects.$id'
import { Route as BillingSuccessRouteImport } from './routes/billing.success'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUsageRoute = SettingsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDownloadsRoute = SettingsDownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectsIdRoute = ProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingSuccessRoute = BillingSuccessRouteImport.update({
  id: '/billing/success',
  path: '/billing/success',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/settings': typeof SettingsRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/success': typeof BillingSuccessRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/downloads': typeof SettingsDownloadsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/sign-in': typeof SignInRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/success': typeof BillingSuccessRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/downloads': typeof SettingsDownloadsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/settings': typeof SettingsRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/success': typeof BillingSuccessRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/downloads': typeof SettingsDownloadsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/settings'
    | '/sign-in'
    | '/auth/callback'
    | '/billing/success'
    | '/projects/$id'
    | '/settings/billing'
    | '/settings/downloads'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/usage'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/sign-in'
    | '/auth/callback'
    | '/billing/success'
    | '/projects/$id'
    | '/settings/billing'
    | '/settings/downloads'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/usage'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/settings'
    | '/sign-in'
    | '/auth/callback'
    | '/billing/success'
    | '/projects/$id'
    | '/settings/billing'
    | '/settings/downloads'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/usage'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SignInRoute: typeof SignInRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BillingSuccessRoute: typeof BillingSuccessRoute
  ProjectsIdRoute: typeof ProjectsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/usage': {
      id: '/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof SettingsUsageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/downloads': {
      id: '/settings/downloads'
      path: '/downloads'
      fullPath: '/settings/downloads'
      preLoaderRoute: typeof SettingsDownloadsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/projects/$id': {
      id: '/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/success': {
      id: '/billing/success'
      path: '/billing/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof BillingSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteChildren {
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsDownloadsRoute: typeof SettingsDownloadsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsUsageRoute: typeof SettingsUsageRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsDownloadsRoute: SettingsDownloadsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsUsageRoute: SettingsUsageRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SignInRoute: SignInRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BillingSuccessRoute: BillingSuccessRoute,
  ProjectsIdRoute: ProjectsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
